<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-06-28 16:01:38
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-08-23 15:18:32
 * @FilePath: \合联\oms\src\view\operation_modules\trackRollback\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/operation_modules/trackRollback";
export default {
  name: "",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        ...apis,
        list: (p) => {
          if (!p.airway_number) return;
          return apis.list(p);
        },
        beforeHandleList({ data }) {
          return data;
        },
      },
      config: {
        isGetList: true,
      },
      footer: {
        show: () => false,
      },
      modals: {},
      header: {
        searchs: [
          {
            key: "status",
            placeholder() {
              return this.$tz("轨迹状态");
            },
            component: "Input",
            options: [],
            optionsFn: "getTrackerStatus",
            optionsKey: "",
          },
          {
            key: "airway_number",
            placeholder() {
              return this.$tz("订单号码");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
            methods: {
              "on-enter"() {
                this.handleSubmit();
              },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
            {
              name: () => this.$tz("批量,隐藏"),
              type: "hide",
              fnName: "hide",
              bind: {
                type: "error",
              },
              id: 1812,
              disabled() {
                return !this.selectAll.length;
              },
            },
          ],
          methods: {
            hide() {
              this.$Modal.confirm({
                title: this.$tz("批量,隐藏"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "batchSaveTrace",
                    { ids: this.selectAll.map((t) => t.id) },
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
            export() {
              this.exportExc();
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 50,
          align: "center",
        },
        {
          name: () => this.$t("orderNum"),
          key: "awbno",
          minWidth: 130,
        },
        {
          name: () => this.$t("tip"),
          key: "status",
          minWidth: 130,
        },
        {
          name: () => this.$tz("是否,显示"),
          key: "is_hidden",
          minWidth: 110,
          methods: {
            render({ value }) {
              return value == 1 ? this.$tz("否") : this.$tz("是");
            },
          },
        },
        {
          name: () => this.$t("payment_description"),
          key: "remarks",
          minWidth: 130,
        },
        {
          name: () => this.$tz("地点"),
          key: "location",
          minWidth: 130,
        },
        {
          name: () => this.$tz("flag"),
          key: "flag",
          minWidth: 210,
        },
        {
          name: () => this.$t("addTime"),
          key: "create_time",
          minWidth: 210,
        },
        {
          name: () => this.$t("operate1"),
          key: "operator",
          minWidth: 130,
        },
        {
          name: () => this.$t("upTime"),
          key: "update_time",
          minWidth: 210,
        },
        {
          name: () => this.$tz("派送司机电话"),
          key: "driver_phone",
          minWidth: 130,
        },
        {
          name: () => this.$t("courier"),
          key: "delivery_agent",
          minWidth: 130,
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 120,
          fixed: "right",
          list: [
            {
              name: (p) => {
                return p && p.row.is_hidden == 1
                  ? this.$tz("显示")
                  : this.$tz("隐藏");
              },
              type: "save",
              fnName: "save",
              bind: {
                type: ({ row }) => (row.is_hidden ? "success" : "error"),
              },
              id: "",
            },
          ],
          methods: {
            save({ row, field }) {
              this.$Modal.confirm({
                title: field.name({ row }),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("saveTrace", row, true, true).then(
                    (res) => {
                      this.getList();
                    }
                  );
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>